var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayroll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 48,
    viewBox: "0 0 64 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8 48C9.28 48 6.26667 46.825 3.76 44.475C1.25333 42.125 0 39.3 0 36V12C0 8.7 1.25333 5.875 3.76 3.525C6.26667 1.175 9.28 0 12.8 0H51.2C54.72 0 57.7333 1.175 60.24 3.525C62.7467 5.875 64 8.7 64 12V36C64 39.3 62.7467 42.125 60.24 44.475C57.7333 46.825 54.72 48 51.2 48H12.8ZM12.8 12.75H51.2C52.7467 12.75 54.2 12.975 55.56 13.425C56.92 13.875 58.1333 14.525 59.2 15.375V12C59.2 9.9 58.4267 8.125 56.88 6.675C55.3333 5.225 53.44 4.5 51.2 4.5H12.8C10.56 4.5 8.66667 5.225 7.12 6.675C5.57333 8.125 4.8 9.9 4.8 12V15.375C5.86667 14.525 7.08 13.875 8.44 13.425C9.8 12.975 11.2533 12.75 12.8 12.75ZM5.04 22.95L43.2 31.575C43.5733 31.675 43.96 31.6875 44.36 31.6125C44.76 31.5375 45.0933 31.375 45.36 31.125L58.16 21.075C57.4667 19.925 56.5067 19 55.28 18.3C54.0533 17.6 52.6933 17.25 51.2 17.25H12.8C10.9333 17.25 9.28 17.7875 7.84 18.8625C6.4 19.9375 5.46667 21.3 5.04 22.95Z",
    fill: "#1773BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayroll);
export default __webpack_public_path__ + "static/media/payroll.40eb39f68c03ce8efbeb7d0371c2450b.svg";
export { ForwardRef as ReactComponent };